import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Target } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const periodLabel = (p) => (p && p.length === 7 ? `${BULAN[Number(p.slice(5, 7)) - 1]} ${p.slice(0, 4)}` : p);

// Dipanggil dari tile "Buka Cabang Baru": tampil hanya saat agen mengklik tombol itu
export function BranchTargetPopup({ open, onClose }) {
  const [cfg, setCfg] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    if (!open) return;
    api.get("/branch-requests/target").then((r) => { setCfg(r.data); if (!r.data.enabled) { onClose(); nav("/buka-cabang"); } }).catch(() => { onClose(); nav("/buka-cabang"); });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!open || !cfg?.enabled) return null;
  const sisa = Math.max(0, cfg.target - (cfg.achieved || 0));
  const go = () => { onClose(); nav("/buka-cabang"); };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm p-0 overflow-hidden" data-testid="branch-target-popup">
        <div className="relative h-44 overflow-hidden bg-sky-100" data-testid="branch-target-image">
          <img src="/cabang-baru.jpg" alt="Teknisi Fasnet bersama tuan rumah di desa dengan server, OLT dan Starlink" className="absolute inset-0 w-full h-full object-cover cabang-hero-anim" />
          <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-2 left-3 right-3 text-white font-heading font-bold text-sm drop-shadow">Bangun cabang baru, bawa internet ke desa</div>
        </div>
        <div className="p-4 pt-3 space-y-3">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 font-heading"><Target className="w-5 h-5 text-[#F04E23]" /> Target Buka Cabang Baru</DialogTitle>
            <DialogDescription className="sr-only">Target buka cabang baru</DialogDescription>
          </DialogHeader>
          <div className="rounded-2xl bg-gradient-to-br from-[#F04E23] to-amber-500 text-white p-4 space-y-1" data-testid="branch-target-card">
            <div className="text-xs font-mono uppercase tracking-wider text-white/80">Target Anda</div>
            <div className="text-3xl font-heading font-bold" data-testid="branch-target-number">{cfg.target} Cabang Baru</div>
            <div className="text-sm font-semibold">pada bulan {periodLabel(cfg.period)}</div>
            <div className="text-xs text-white/90 font-mono pt-1" data-testid="branch-target-progress">Tercapai {cfg.achieved || 0} / {cfg.target} · sisa {sisa}</div>
            <div className="h-1.5 rounded-full bg-white/30 overflow-hidden"><div className="h-full bg-white rounded-full transition-all" style={{ width: `${Math.min(100, ((cfg.achieved || 0) / cfg.target) * 100)}%` }} /></div>
          </div>
          {cfg.message && <p className="text-xs text-muted-foreground leading-relaxed" data-testid="branch-target-message">{cfg.message}</p>}
          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" onClick={onClose} data-testid="branch-target-close">Nanti</Button>
            <Button onClick={go} className="bg-sky-600 hover:bg-sky-700 text-white" data-testid="branch-target-go"><Building2 className="w-4 h-4 mr-1.5" /> Lanjut Ajukan</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
